import React, { useEffect, useState } from "react";
import { Card, Table, Tag, Empty, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { listVisits } from "../../network/api";
import { relativeTime } from "../../constants/health";
import {
  VISIT_TYPE_LABEL,
  VISIT_TYPE_TAG_COLOR,
  VISIT_STATUS_LABEL,
  VISIT_STATUS_TAG_COLOR,
} from "../../constants/visits";

// D2-T6 — compact visit/maintenance log, filtered by device or outlet.
export default function VisitLog({ deviceId, shop, title = "Recent Visits" }) {
  const navigate = useNavigate();
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!deviceId && !shop) return;
    setLoading(true);
    listVisits({ deviceId, shop, pageSize: 10 })
      .then((r) => setVisits(r.data || []))
      .catch(() => setVisits([]))
      .finally(() => setLoading(false));
  }, [deviceId, shop]);

  const columns = [
    { title: "Type", dataIndex: "visitType", render: (t) => <Tag color={VISIT_TYPE_TAG_COLOR[t]}>{VISIT_TYPE_LABEL[t] || t}</Tag> },
    ...(shop ? [{ title: "Device", dataIndex: "deviceId", render: (v) => v || "—" }] : []),
    { title: "Technician", key: "tech", render: (_, r) => r.technician?.name || "—" },
    { title: "Status", dataIndex: "status", render: (s) => <Tag color={VISIT_STATUS_TAG_COLOR[s]}>{VISIT_STATUS_LABEL[s] || s}</Tag> },
    { title: "When", dataIndex: "updatedAt", render: (v) => (v ? relativeTime(v) : "—") },
    { title: "", key: "x", align: "right", render: (_, r) => <Button type="link" onClick={() => navigate(`/dashboard/visit-detail/${r._id}`)}>View</Button> },
  ];

  return (
    <Card title={title}>
      <Table
        rowKey="_id"
        size="small"
        loading={loading}
        columns={columns}
        dataSource={visits}
        pagination={false}
        locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No visits yet" /> }}
      />
    </Card>
  );
}
